/**
 * Copyright © PlanMaster Fogászati Szoftver Kft. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Tamas Neufeld <tamas.neufeld@planmaster3d.com>, 2017
 */

const StateEngine = {
    debug: false,
    status: [],
    treatments: [],
    generatedStatus: {},
    generatedStatusOnly: {},
    config: {
        '1': {
            name: 'healthy',
            replace: ['root', 'neck', 'crown'],
        },
        '2': {
            name: 'extract',
            replace: ['root'],
            remove: ['neck', 'crown'],
            allow: [ 10, 11, 15, 19, 300, 303, 308, 309, 318, 14 ],
        },
        '3': {
            name: 'caries',
            replace: ['crown'],
        },
        '4': {
            name: 'filling - amalgam',
            replace: ['crown'],
            allowOn: [
                { root: [1,201] }
            ],
            denyOn: [
                { crown: [9,15] }
            ]
        },
        '5': {
            name: 'filling - old composite',
            replace: ['crown'],
        },
        '28': {
            name: 'fractured',
            replace: ['crown'],
        },
        '29': {
            name: 'radix',
            replace: ['root'],
            remove: ['neck','crown'],
        },
        '30': {
            name: 'discoloured',
            replace: ['crown'],
        },
        '31': {
            name: 'impacted',
            replace: ['crown'],
            allow: [33,14]
        },

        '10': {
            name: 'implant - one phase',
            replace: ['root'],
            remove: ['neck', 'crown'],
            allowOn: [
                { root: [2,10,33] },
            ],
            denyOn: [
                { crown: [9,15,300]}
            ],
            allow: [33,9,10,15,300,303,14]
        },
        '318': {
            name: 'implant - one phase',
            replace: ['root'],
            remove: ['neck', 'crown'],
            allowOn: [
                { root: [2,10,318,33] },
            ],
            denyOn: [
                { crown: [9,15,300]}
            ],
            allow: [33,9,10,15,300,303,14]
        },
        '11': {
            ignoreSame: true,
            name: 'implant',
            replace: ['root'],
            remove: ['neck','crown'],
            allowOn: [
                { root: [2,33] },
            ],
            denyOn: [
                { crown: [9,15,300]}
            ],
            allow: [33,12,13,311,9,15,14,303]
        },
        '312': {
            ignoreSame: true,
            name: 'implant',
            replace: ['root'],
            remove: ['neck','crown'],
            allowOn: [
                { root: [2,33] },
            ],
            denyOn: [
                { crown: [9,15,300]}
            ],
            allow: [33,12,13,311,9,15,14,303]
        },
        '16': {
            name: 'worn teeth',
            replace: ['crown'],
        },
        '21': {
            name: 'crown - gold',
            replace: ['crown'],
        },
        '22': {
            name: 'filling - gold',
            replace: ['crown'],
        },
        '33': {
            ignoreMissing: true,
            name: 'extract',
            replace: ['root'],
            remove: ['neck', 'crown'],
            allow: [ 10, 11, 13, 311, 15, 19, 33, 300, 303, 308, 309, 318, 14 ],
            denyOn: [
                { selection: 'all', root: [2,33] },
            ],
            beforeAdd: [
                {
                    rule: 'ignore',
                    conditions: {
                        root: [2,33]
                    }
                }
            ]
        },
        '300': {
            name: 'denture',
            replace: ['crown'],
            allowOn: [
                { root: [2,33,10,13, 311, 318] },
            ],
            allow: [200, 14]
        },
        '303': {
            /*name: 'denture',
            replace: ['crown'],
            allowOn: [
                { root: [2,33,10,13, 311, 318] },
            ],
            allow: [ 200, 14 ],
            minSelected: 6,*/
            name: 'bridge',
            replace: ['crown'],
            minSelected: 2,
            denyOn: [
                { selection: 'all', root: [2,33,29] },
                { neck: [8] },
                { crown: [9,15,300] },
            ],
            callback: function(tId, sId, scenario) {
                this.addFiledNeckOnExisting(tId, sId, scenario);
            },
        },
        '308': {
            name: 'denture',
            replace: ['crown'],
            allowOn: [
                { root: [2,33,10,13, 311, 318] },
            ],
            allow: [200, 14]
        },
        '309': {
            name: 'denture',
            replace: ['crown'],
            allowOn: [
                { root: [2,33,10,13,311,318] },
            ],
            allow: [200, 14]
        },






        // Basic states



        '6': {
            name: 'post - composite',
            replace: ['neck'],
            remove: ['crown'],
            denyOn: [
                { crown: [9,15] }
            ],
            allow: [8,6,7,9,15,33, 14, 201,303],
            callback: function(tId, sId, scenario) {
                this.replaceRadix(tId, sId, scenario);
            },
        },
        '7': {
            name: 'post - metal',
            replace: ['neck'],
            remove: ['crown'],
            denyOn: [
                { crown: [9,15] }
            ],
            allow: [8,6,7,9,15,33,14, 201,303],
            callback: function(tId, sId, scenario) {
                this.replaceRadix(tId, sId, scenario);
            },
        },
        '8': {
            name: 'post prep',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [0,1,201,29] }
            ],
            allow: [33,6,7,14, 201],
            callback: function(tId, sId, scenario) {
                this.replaceRadix(tId, sId, scenario);
            },
        },
        '9': {
            //ignoreMissing: true,
            ignoreSame: true,
            name: 'crown',
            replace: ['crown'],
            denyOn: [
                { root: [2,33,29] },
                { neck: [8] },
                { crown: [9,15,300] },
            ],
            callback: function(tId, sId, scenario) {
                this.addFiledNeckOnExisting(tId, sId, scenario);
            },
        },
        '12': {
            name: 'implant healing screw',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [11,13,311] }
            ],
            allow: [13,311,9,15,33,300,303,14,924],
            callback: function(tId, sId, scenario) {
                this.addImplants(tId, sId, scenario);
            },
        },
        '924': {
            name: 'implant healing screw',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [11,12,13,311] }
            ],
            allow: [13,311,9,15,33,300,303,14,924,12],
            callback: function(tId, sId, scenario) {
                this.addImplants(tId, sId, scenario);
            },
        },
        '13': {
            name: 'implant abutement',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [11,12] }
            ],
            allow: [9,15,12,33,300,303,14],
            callback: function(tId, sId, scenario) {
                this.addImplants(tId, sId, scenario);
            },
        },
        '311': {
            name: 'implant abutement',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [11,12] }
            ],
            allow: [9,15,12,33,300,303,14],
            callback: function(tId, sId, scenario) {
                this.addImplants(tId, sId, scenario);
            },
        },
        '14': {
            name: 'impression',
            allowOn: [
                { root: [0,1,201,10,11,29] }
            ]
        },
        '15': {
            name: 'bridge',
            replace: ['crown'],
            minSelected: 2,
            denyOn: [
                { selection: 'all', root: [2,33,29] },
                { neck: [8] },
                { crown: [9,15,300] },
            ],
            callback: function(tId, sId, scenario) {
                this.addFiledNeckOnExisting(tId, sId, scenario);
            },
        },

        '17': {
            name: 'inlay prep',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [0,1,29,201] }
            ]
        },
        '18': {
            name: 'inlay',
            replace: ['crown'],
            allowOn: [
                //{ neck: [17] }
                { root: [1,201] }
            ],
            denyOn: [
                { crown: [9,15] }
            ]
        },
        '19': {
            ignoreMissing: true,
            ignoreSame: true,
            name: 'filing',
            replace: ['neck'],
            remove: ['crown'],
            allow: [9,15,19,33,6,7,8,201,14,303],
            allowOn: [
                { root: [0,1,29,201] }
            ],
            beforeAdd: [
                {
                    rule: 'ignore',
                    conditions: {
                        root: [2,33],
                    }
                }
            ]
        },

        '23': {
            name: 'onlay prep',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [0,1,201] }
            ],
            denyOn: [
                { crown: [9,15] }
            ]
        },
        '24': {
            name: 'onlay',
            replace: ['crown'],
            allowOn: [
                //{ neck: [23] }
                { root: [1,201] }
            ],
            denyOn: [
                { crown: [9,15] }
            ]
        },
        '25': {
            name: 'veneer prep',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { root: [0,1,201] }
            ]
        },
        '26': {
            name: 'veneer',
            replace: ['crown'],
            allowOn: [
                //{ neck: [25] }
                { root: [1,201] }
            ],
            denyOn: [
                { crown: [9,15] }
            ]
        },
        '27': {
            name: 'filling - white',
            replace: ['crown'],
            allowOn: [
                { root: [1,201] }
            ],
            denyOn: [
                { crown: [9,15,300] }
            ]
        },


        '200': {
            name: 'bridge removal',
            remove: ['crown'],
            allowOn: [
                { crown: [9,15,300,303,308] }
            ],
            callback: function(tId, sId, scenario) {
                this.addFiledNeckOnExisting(tId, sId, scenario);
            },
        },
        '201': {
            name: 'root canal treatment',
            replace: ['root'],
        },
        '204': {
            name: 'root canal treatment',
            replace: ['root'],
            allowOn: [
                { root: [1,29,201] }
            ]
        },
        '207': {
            name: 'other',
            replace: [],
        },
        '208': {
            name: 'other',
            replace: [],
        },

        '302': {
            name: 'precivertix',
            replace: ['crown'],
            allowOn: [
                { crown: [9,15] }
            ]
        },


        '304': {
            name: 'denture screw',
            allowOn: [
                { root: [0] },
            ],
        },

        '305': {
            name: 'telescopic crown',
            replace: ['neck'],
            remove: ['crown'],
            allowOn: [
                { neck: [19] }
            ]
        },

        '306': {
            name: 'bridge - precivertix',
            replace: ['crown'],
            allowOn: [
                { neck: [19] }
            ],
            beforeAdd: [
                {
                    rule: 'ignore',
                    conditions: {
                        crown: [15, 302]
                    }
                }
            ]
        },

    },

    init: function(status, steps) {
        this.setStatus(status);
        this.setSteps(steps);
        this.generateStatus();
        if(this.debug) Debug.info('State Engine inited', this);
    },

    update: function(status, steps) {
        this.setStatus(status);
        this.setSteps(steps);
        this.generateStatus();
        if(this.debug) Debug.info('State Engine data updated', this);
        window.app.$bus.$emit('state-engine:update');
    },

    setStatus: function(status){
        this.status = status;
    },
    setSteps: function(steps){
        this.steps = steps;
    },

    updateStatus: function(status){
        this.status = status;
        this.generateStatus();
        Debug.info('State Engine data updated', this);
        window.app.$bus.$emit('state-engine:update');
    },
    updateSteps: function(steps){
        this.steps = steps;
        this.generateStatus();
        Debug.info('State Engine data updated', this);
        window.app.$bus.$emit('state-engine:update');
    },

    getLabelStyle: function(tooth, mode) {
        let s = this.getToothStatus(tooth);
        let style = {};
        let untreated = {
            background: '#BCAAA4', // brown lighten-3
            color: '#FFF',
        };
        let untreatedOutline = {
            borderWidth: '1px',
            borderStyle: 'solid',
            padding: '0px 2px!important',
            color: '#795548', // brown
        };
        let unfinished = {
            //background: '#FFEB3B', // yellow
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: '#795548',
            padding: '0px 2px!important',
            color: '#fff',
            background: '#81C784', // green lighten-2
        };
        let finished = {
            background: '#81C784', // green lighten-2
            color: '#FFF',
        };
        let finishedOutline = {
            borderWidth: '1px',
            borderStyle: 'solid',
            padding: '0px 2px!important',
            color: '#4CAF50', // green
        };

        if(mode === 'treatments') {
            let hasTreatment = (typeof s.steps === 'object' && s.steps.length > 0);
            let plannedToday = (app.$store.state.activePatient.activeTab === 'tab-treatments' && this.isToothPlanned(tooth));
            let plannedNext = (app.$store.state.activePatient.activeTab === 'tab-treatments' && this.isToothInUpcomingTreatments(tooth));
            if(plannedNext && hasTreatment) return unfinished;
            if(plannedToday && !hasTreatment) return untreatedOutline;
            if(plannedNext && !hasTreatment) return finishedOutline;
            if(hasTreatment) return this.isTreatmentFinished(s);
            if(plannedNext && plannedNext) return untreatedOutline;

            for(let i in s.status) {
                if (s.status[i].title === app.$t('dialog_select_status.treatable')) return untreatedOutline;
            }
        } else {
            if(app.$store.state.activePatient.activeTab === 'tab-treatments' && this.isToothPlanned(tooth)) return untreatedOutline;
            for(let i in s.status) {
                if (s.status[i].title === app.$t('dialog_select_status.treatable')) return untreatedOutline;
            }
        }
        return null;

        if(mode === 'treatments') {
            if(typeof s.steps === 'object' && s.steps.length > 0) {

                /*if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && !s.crown) return unfinished;
                if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && s.crown && s.steps.length>0) return finished;
                if((parseInt(s.crown)===9 || parseInt(s.crown)===15 || parseInt(s.crown)===300 || parseInt(s.crown)===303 || parseInt(s.crown)===308) && s.steps.length>0) return finished;
                if((parseInt(s.root)===1 || parseInt(s.root)===201) && !s.crown) return unfinished;
                if((parseInt(s.root)===1 || parseInt(s.root)===201) && s.crown && s.steps.length>0) return finished;
                if(parseInt(s.root)===33 && !s.crown) return finishedOutline;
                if(typeof this.generatedStatus[String(tooth)].steps !== "undefined" && this.generatedStatus[String(tooth)].steps.length > 0) return finished;
                return unfinished;*/


                if(app.$store.state.activePatient.activeTab === 'tab-treatments' && this.isToothInUpcomingTreatments(tooth)) {
                    if(app.$store.state.activePatient.treatments[0].state === 1) return untreatedOutline;
                    return finishedOutline;
                }
                return finished;
            }
            if(app.$store.state.activePatient.activeTab === 'tab-treatments' && this.isToothInUpcomingTreatments(tooth)) {
                if(app.$store.state.activePatient.treatments[0].state === 1) return untreatedOutline;
                return finishedOutline;
            }
            for(let i in s.status) {
                if (s.status[i].title === app.$t('dialog_select_status.treatable')) return untreatedOutline;
            }
        } else {
            if(this.isToothPlanned(tooth)) return untreatedOutline;
            for(let i in s.status) {
                if (s.status[i].title === app.$t('dialog_select_status.treatable')) return untreatedOutline;
                //if (s.status[i].state_id === 2) return untreatedOutline;
                //if (s.status[i].state_id === 3) return untreated;
            }
            //if(s.status.length > 1 || (s.status.length === 1 && s.status[0].state_id !== 1)) return untreatedOutline;
            return null;
        }

        /*for(let i in s.status) {
            if(s.status[i].title === app.$t('dialog_select_status.treatable')) {
                if(mode === 'treatments' && typeof s.steps === 'object' && s.steps.length > 0) {
                    if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && !s.crown) return unfinished;
                    if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && s.crown && s.steps.length>0) return finished;
                    if((parseInt(s.crown)===9 || parseInt(s.crown)===15 || parseInt(s.crown)===300 || parseInt(s.crown)===303 || parseInt(s.crown)===308) && s.steps.length>0) return finished;
                    if((parseInt(s.root)===1 || parseInt(s.root)===201) && !s.crown) return unfinished;
                    if((parseInt(s.root)===1 || parseInt(s.root)===201) && s.crown && s.steps.length>0) return finished;
                    if(typeof this.generatedStatus[String(tooth)].steps !== "undefined" && this.generatedStatus[String(tooth)].steps.length > 0) return finished;


                    return unfinished;
                }
                return untreated;
            }
        }

        if((parseInt(s.root)===1 && parseInt(s.neck)===1 && parseInt(s.crown)===1)) return null;
        if(parseInt(s.root)===2 && !s.neck && !s.crown) return untreatedOutline;
        if(parseInt(s.root)===33 && !s.neck && !s.crown) return finishedOutline;
        if(parseInt(s.crown)===3 || parseInt(s.root)===29 || parseInt(s.crown)===30 || parseInt(s.crown)===16 || parseInt(s.crown)===28) return untreated;

        if(mode === 'treatments') {
            if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && !s.crown) return unfinished;
            if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && s.crown && s.steps.length>0) return finished;
            if((parseInt(s.crown)===9 || parseInt(s.crown)===15 || parseInt(s.crown)===300 || parseInt(s.crown)===303 || parseInt(s.crown)===308) && s.steps.length>0) return finished;
            if((parseInt(s.root)===1 || parseInt(s.root)===201) && !s.crown) return unfinished;
            if((parseInt(s.root)===1 || parseInt(s.root)===201) && s.crown && s.steps.length>0) return finished;
            if(typeof this.generatedStatus[String(tooth)].steps !== "undefined" && this.generatedStatus[String(tooth)].steps.length > 0) return finished;
        }
        if(parseInt(s.root)===201 || parseInt(s.crown)===18 || parseInt(s.crown)===26) return untreatedOutline;
        if(typeof s.status === 'object' && s.status.length > 0 && parseInt(s.status[0].state_id) !== 1) return untreatedOutline;
        else return null;*/
    },

    isTreatmentFinished: function(s) {
        let unfinished = {
            //background: '#FFEB3B', // yellow
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: '#795548',
            padding: '0px 2px!important',
            color: '#fff',
            background: '#81C784', // green lighten-2
        };
        let finished = {
            background: '#81C784', // green lighten-2
            color: '#FFF',
        };
        let finishedOutline = {
            borderWidth: '1px',
            borderStyle: 'solid',
            padding: '0px 2px!important',
            color: '#4CAF50', // green
        };

        try {
            if (typeof s.steps === 'object' && s.steps.length > 0) {
                if ((parseInt(s.root) === 10 || parseInt(s.root) === 11 || parseInt(s.root) === 318) && !s.crown) return unfinished;
                if ((parseInt(s.root) === 10 || parseInt(s.root) === 11 || parseInt(s.root) === 318) && s.crown && s.steps.length > 0) return finished;
                if ((parseInt(s.crown) === 9 || parseInt(s.crown) === 15 || parseInt(s.crown) === 300 || parseInt(s.crown) === 303 || parseInt(s.crown) === 308) && s.steps.length > 0) return finished;
                if ((parseInt(s.root) === 1 || parseInt(s.root) === 201) && !s.crown) return unfinished;
                if ((parseInt(s.root) === 1 || parseInt(s.root) === 201) && s.crown && s.steps.length > 0) return finished;
                if (parseInt(s.root) === 33 && !s.crown) return finishedOutline;
                if (typeof this.generatedStatus[String(tooth)].steps !== "undefined" && this.generatedStatus[String(tooth)].steps.length > 0) return finished;
                //return unfinished;
                return finishedOutline;
            }

            return finishedOutline;
        } catch(error) {
            captureException(error);
            return finishedOutline;
        }
    },

    isToothPlanned: function(tooth) {
        try {
            let source = [];
            if(typeof app.$store.state.activePatient.treatments[1] !== 'undefined') source = app.$store.state.activePatient.treatments[1].treatmentData.upcoming_treatment_steps;
            else return false;
            for(let i in source) {
                if(typeof source[i].tooth_id !== 'undefined' && source[i].tooth_id.indexOf(tooth) >=0) return true;
            }
            return false;
        } catch(error) {
            captureException(error);
            return false;
        }
    },

    isToothInUpcomingTreatments: function(tooth) {
        try {
            let source = [];
            if(typeof app.$store.state.activePatient.upcomingTreatments !== 'undefined' && app.$store.state.activePatient.upcomingTreatments.length > 0) source = app.$store.state.activePatient.upcomingTreatments;
            else return false;
            for(let i in source) {
                if(typeof source[i].tooth_id !== 'undefined' && source[i].tooth_id.indexOf(tooth) >=0) return true;
            }
            return false;
        } catch(error) {
            captureException(error);
            return false;
        }
    },

    getLabelColor: function(tooth) {
        let s = this.getToothStatus(tooth);
        let untreated = 'brown lighten-3 white--text';
        let untreated2 = 'brown--text';
        let unfinished = 'yellow';
        let finished = 'green lighten-2 white--text';

        if(parseInt(tooth) === 27) {

        }
        for(let i in s.status) {
            if(s.status[i].title === app.$t('dialog_select_status.treatable')) {
                if(typeof s.steps === 'object' && s.steps.length > 0) return unfinished;
                return untreated;
            }
        }

        if((parseInt(s.root)===1 && parseInt(s.neck)===1 && parseInt(s.crown)===1)) return null;
        if(((parseInt(s.root)===2 || parseInt(s.root)===33) && !s.neck && !s.crown)) return null;
        if((parseInt(s.crown)===3 || parseInt(s.root)===29 || parseInt(s.crown)===30 || parseInt(s.crown)===16 || parseInt(s.crown)===28)) return untreated;
        if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && !s.crown) return unfinished;
        if((parseInt(s.root)===10 || parseInt(s.root)===11 || parseInt(s.root)===318) && s.crown && s.steps.length>0) return finished;
        if((parseInt(s.root)===1 || parseInt(s.root)===201) && !s.crown) return unfinished;
        if((parseInt(s.root)===1 || parseInt(s.root)===201) && s.crown && s.steps.length>0) return finished;
        if((parseInt(s.crown)===9 || parseInt(s.crown)===15 || parseInt(s.crown)===300 || parseInt(s.crown)===303 || parseInt(s.crown)===308) && s.steps.length>0) return finished;

        if(typeof this.generatedStatus[String(tooth)].steps !== "undefined" && this.generatedStatus[String(tooth)].steps.length > 0) return finished;

        if(typeof s.status === 'object' && s.status.length > 0 && parseInt(s.status[0].state_id) !== 1) return untreated2;

        else return null;
    },

    filterBeforeAdd: function(state, selection) {
        var state = window.app.$store.getters.dentalStateById(state);
        if(typeof(this.config[state.parent_id])==='undefined' || typeof(this.config[state.parent_id].beforeAdd)==='undefined') return selection;
        for (let i in this.config[state.parent_id].beforeAdd) {
            var filteredSelection = [];
            for(let t in selection) {
                var filter = this.config[state.parent_id].beforeAdd[i];
                var matching = this.isRuleMatching(filter.conditions,selection[t]);
                if((matching && filter.rule==='include') || (!matching && filter.rule==='ignore')) filteredSelection.push(selection[t]);
            }
            selection = JSON.parse(JSON.stringify(filteredSelection));
        }
        return selection;
    },

    generateStatus: function() {
        this.generatedStatus = {};
        this.generatedStatusOnly = {};
        var regionId = 1;
        var toothId = 1;
        this.generatedStatus['0'] = { root: 1, neck: 1, crown: 1, steps: [], status: [] };
        while(regionId<=4 && toothId<=8) {
            this.generatedStatus[String((regionId*10 + toothId))] = { root: 1, neck: 1, crown: 1, steps: [], status: [] };
            if(toothId === 8) {
                toothId = 1;
                regionId++;
            } else {
                toothId++;
            }
        }
        for(let i in this.status) {
            try{
                var tooth = String(this.status[i].tooth_id);
                if (tooth === 'null') tooth = '0';
                var state = String(this.status[i].state_pid);
                if(typeof(this.config[state])==='undefined') continue;
                if(typeof this.generatedStatus[tooth].statusMap === 'undefined') this.generatedStatus[tooth].statusMap = {};
                var cfg = this.config[state];
                this.generatedStatus[tooth].status.push(this.status[i]);
                this.generatedStatus[tooth].statusMap[String(this.generatedStatus[tooth].status.length-1)] = i;
                if(typeof(cfg.remove)!=='undefined') {
                    this.removeParts(tooth,state,cfg.remove);
                }
                if(typeof(cfg.replace)!=='undefined') {
                    this.replaceParts(tooth,state,cfg.replace);
                }
                if(typeof(cfg.callback)!=='undefined') {
                    cfg.callback.call(this, tooth, state, 'status');
                }
            } catch (error) {
                captureException(error);
                Debug.error({error, module: 'state-engine', data: this.status[i]});
                app.$bus.$emit('state-engine:error');
            }
        }
        this.generatedStatusOnly = JSON.parse(JSON.stringify(this.generatedStatus));
        for(let i in this.steps) {
            try{
                if(typeof this.steps[i].hidden !== 'undefined' && this.steps[i].hidden) continue;
                if(this.steps[i].active === false) continue;
                var teeth = String(this.steps[i].tooth_id).split(',');
                for(let t in teeth) {
                    var tooth = String(teeth[t]);
                    if (tooth === 'null') tooth = '0';
                    var state = String(this.steps[i].state_pid);
                    if(typeof(this.config[state])==='undefined') {
                        if(this.debug) Debug.info('Could not find state engine config for treatment '+state);
                        continue;
                    }
                    var cfg = this.config[state];
                    if(typeof(this.generatedStatus[tooth])==='undefined') continue;
                    this.generatedStatus[tooth].steps.push(this.steps[i]);
                    if(typeof(cfg.remove)!=='undefined') {
                        this.removeParts(tooth,state,cfg.remove);
                    }
                    if(typeof(cfg.replace)!=='undefined') {
                        this.replaceParts(tooth,state,cfg.replace);
                    }
                    if(typeof(cfg.callback)!=='undefined') {
                        cfg.callback.call(this, tooth, state, 'step');
                    }
                }
            } catch (error) {
                captureException(error);
                Debug.error({error, module: 'state-engine', data: this.steps[i]});
                app.$bus.$emit('state-engine:error', error);
            }
        }
        if(this.debug) Debug.info('State Engine status generated', this);
    },

    replaceParts: function(tooth, state, parts) {
        if(typeof(this.generatedStatus[tooth])==='undefined') {
            this.generatedStatus[tooth] = {};
        }
        for(let p in parts) {
            this.generatedStatus[tooth][parts[p]] = parseInt(state);
        }
    },

    removeParts: function(tooth, state, parts) {
        if(typeof(this.generatedStatus[tooth]) === 'undefined') return;

        for(let p in parts) {
            if(typeof(this.generatedStatus[tooth][parts[p]]) !== 'undefined') {
                delete this.generatedStatus[tooth][parts[p]];
            }
        }
    },

    getStatus: function(){},

    getToothStatus: function(tooth){
        return this.generatedStatus[tooth];
    },

    isAllowed: function(state, teethIds) {
        // @todo: allow all "other/custom" states
        state = String(state);
        if(typeof(this.config[state])==='undefined') return true;

        if(typeof(this.config[state].ignoreSame)!=='undefined') {
            var t = teethIds.length;
            while (t > 0) {
                t--;
                var tooth = String(teethIds[t]);
                var rootState = null;
                var neckState = null;
                var crownState = null;
                if(typeof(this.generatedStatus[tooth]['root'])!=='undefined') rootState = this.generatedStatus[tooth]['root'];
                if(typeof(this.generatedStatus[tooth]['neck'])!=='undefined') neckState = this.generatedStatus[tooth]['neck'];
                if(typeof(this.generatedStatus[tooth]['crown'])!=='undefined') crownState = this.generatedStatus[tooth]['crown'];
                if(parseInt(rootState) === parseInt(state) || parseInt(neckState) === parseInt(state) || parseInt(crownState) === parseInt(state)) teethIds.splice(t,1);
            }
        }

        if(typeof(this.config[state].ignoreMissing)!=='undefined') {
            var t = teethIds.length;
            while (t > 0) {
                t--;
                var tooth = String(teethIds[t]);
                var rootState = null;
                var neckState = null;
                var crownState = null;
                if(typeof(this.generatedStatus[tooth]['root'])!=='undefined') rootState = this.generatedStatus[tooth]['root'];
                if(typeof(this.generatedStatus[tooth]['neck'])!=='undefined') neckState = this.generatedStatus[tooth]['neck'];
                if(typeof(this.generatedStatus[tooth]['crown'])!=='undefined') crownState = this.generatedStatus[tooth]['crown'];
                if((parseInt(rootState) === 2 || parseInt(rootState) === 33) && !neckState && !crownState) teethIds.splice(t,1);
            }
        }

        if(teethIds.length === 0) {
            return false;
        }

        // Use min/max rules
        if(typeof(this.config[state].minSelected)!=='undefined') {
            if(teethIds.length < this.config[state].minSelected) return false;
        }

        // Use allow rules
        for (let t in teethIds) {
            var tooth = String(teethIds[t]);
            // Get the uppermost part (crown -> neck -> root)
            if(typeof(this.generatedStatus[tooth])!=='object') this.generatedStatus[tooth] = {
                root: '1',
                neck: '1',
                crown: '1'
            };
            if(typeof(this.generatedStatus[tooth]['root'])!=='undefined') var partState = this.generatedStatus[tooth]['root'];
            if(typeof(this.generatedStatus[tooth]['neck'])!=='undefined') var partState = this.generatedStatus[tooth]['neck'];
            if(typeof(this.generatedStatus[tooth]['crown'])!=='undefined') var partState = this.generatedStatus[tooth]['crown'];

            //@todo: filter "other/custom" states
            if(typeof(this.config[partState])==='undefined') continue;

            // See if is any allow rules defined for the state of the uppermost part
            if(typeof(this.config[partState].allow)!=='undefined') {
                var rule = this.config[partState].allow;
                // If allow rule is defined match it with the state, return false or continue
                if(rule.indexOf(parseInt(state))<0) {
                    return false;
                }
            }
        }


        //  Use allowOn rules
        if(typeof(this.config[state].allowOn)!=='undefined') {
            var rules = this.config[state].allowOn;
            for (let t in teethIds) {
                var matched = false;
                var tooth = String(teethIds[t]);
                for (let r in rules) { // Rules are working as "OR" statement
                    var matchedCase = this.isRuleMatching(rules[r],tooth);
                    if (matchedCase) {
                        matched = true; // One "OR" group is true, break the loop
                        break;
                    }
                }
                if (!matched) return false; // If any of the teeth are not matched return false
            }
        }

        // Use denyOn rules
        if(typeof(this.config[state].denyOn)!=='undefined') {
            var rules = this.config[state].denyOn;
            for (let r in rules) { // Rules are working as "OR" statement
                var matchedToTooth = 0;
                var matched = false;
                for (let t in teethIds) {
                    var matchedCase = this.isRuleMatching(rules[r],String(teethIds[t]));
                    if(matchedCase) {
                        if(typeof(rules[r].selection)!=='undefined' && rules[r].selection==='all') matchedToTooth++;
                        else return false; // One "OR" group is true, break the loop
                    }
                }
                if(teethIds.length === matchedToTooth) return false; // Rule contains "seletion=all"
            }
        }


        // Use denyOn rules
        /*if(typeof(this.config[state].denyOn)!=='undefined') {
            var rules = this.config[state].denyOn;
            var appliedToTooth = 0;
            for (let t in teethIds) {
                var matched = false;
                var tooth = String(teethIds[t]);
                for (let r in rules) { // Rules are working as "OR" statement
                    var matchedCase = this.isRuleMatching(rules[r],tooth);
                    if(typeof(rules[r].selection)!=='undefined' && rules[r].selection==='all') {
                        appliedToTooth++;
                    } else if (matchedCase) {
                        matched = true; // One "OR" group is true, break the loop
                        break;
                    }
                }
                if (matched) return false; // If any of the teeth are matched return false
            }
        }*/

        return true;

        /*

        OK - Ha van fog nem mehet ra impi (vagy felépítmény/csavar) es fogsor

        OK - Ha van fogsor akkor nem lehet huzas ne menjen ra hid korona tomes gyokerkezeles… csak implant vagy masik fogsor (lehet fogsornál lehet csak levételt / cserét kellene / egyéb)

        OK - Ha van korona akkor nem mehet ra fogsor vagy implant

        OK - Ha van implant nem lehet tomni gyokerkezekes stb csak korona vagy hid (vagy felépítmény / csavar)

        Ha nincs fog egyaltalan a kijelolesekben akkor ne menjen ra csak fogsor vagy implant*/

    },

    isRuleMatching: function(rule, tooth) {
        for (let part in rule) { // Sub-rules are working as "AND" statement
            if (rule.hasOwnProperty(part)) {
                if(part==='selection') continue;
                if (typeof(this.generatedStatus[tooth]) === 'undefined') return false;
                if (typeof(this.generatedStatus[tooth][part]) === 'undefined') return false;
                if (rule[part].indexOf(parseInt(this.generatedStatus[tooth][part])) < 0) return false;
            }
        }
        return true;
    },

    modifySelectionByRule: function(rule, baseSelection) {
        switch(rule) {
            case 'only_existing':
                return this.modifySelectionByRule_onlyExisting(baseSelection);
                break;
        }
    },

    modifySelectionByRule_onlyExisting: function(baseSelection) {
        var modifiedSelection = [];
        for(let i in baseSelection) {
            var status = this.generatedStatus[String(baseSelection[i])];
            if((parseInt(status.root)!==2 && parseInt(status.root)!==33) || (typeof(status.neck)!=='undefined' && parseInt(status.neck)!==2 && parseInt(status.neck)!==33) || (typeof(status.crown)!=='undefined' && parseInt(status.crown)!==2 && parseInt(status.crown)!==33)) {
                modifiedSelection.push(baseSelection[i]);
            }
        }
        return modifiedSelection;
    },

    replaceRadix: function(tId, sId, scenario) {
        if(this.debug) Debug.info('Called replaceRadix, tId: '+tId+', sId: '+sId+', scenario: '+scenario);
        if(typeof(this.generatedStatus[tId].root)!=='undefined' && parseInt(this.generatedStatus[tId].root)===29) {
            this.generatedStatus[tId].root = 1;
        }
    },

    addFiledNeckOnExisting: function(tId, sId, scenario) {
        if(this.debug) Debug.info('Called addFiledNeckOnExisting, tId: '+tId+', sId: '+sId+', scenario: '+scenario);
        if(typeof(this.generatedStatus[tId].root)!=='undefined' && parseInt(this.generatedStatus[tId].root)===1) {
            if(typeof(this.generatedStatus[tId].neck)==='undefined' || ([6,7,11,12,13].indexOf(parseInt(this.generatedStatus[tId].neck))<0)) this.generatedStatus[tId].neck = 19;
        }
    },

    addImplants: function(tId, sId, scenario) {
        if (this.debug) Debug.info('Called addImplants, tId: ' + tId + ', sId: ' + sId + ', scenario: ' + scenario);
        if (typeof(this.generatedStatus[tId].root) === 'undefined' || parseInt(this.generatedStatus[tId].root) !== 11) this.generatedStatus[tId].root = 11;
    }

};

window.StatusEngine = StateEngine;

export default StateEngine;
